export default __webpack_public_path__ + "media/images/icons_fc/user-0228ac1436482c920a5dcaafdf2ebb15.png";